import Carousel from "@stimulus-components/carousel";

export default class extends Carousel {
  // we pass in the slides additionally, because `swiper.slides` jumbles up the ordering
  static values = { options: Object, slidesMeta: Array };

  // You can set default options in this getter.
  get defaultOptions() {
    return {
      pagination: {
        el: ".swiper-pagination",
        clickable: true,
        type: "custom",
        renderCustom: (swiper, current, total) => {
          let html = ``;
          this.slidesMetaValue.forEach((slideMeta, index) => {
            const title = slideMeta.title;
            html += `<span class="inline-block ${index == current - 1 ? "text-white" : "text-white/50"} w-24 lg:w-64 space-y-2"><div class="h-px border ${index == current - 1 ? "border-white" : "border-white/50"}"></div><div>${title}</div></span>`;
          });
          return html;
        },
      },
    };
  }
}
